<template>
    <ValidationObserver ref="form">
        <h3 class="profile__ttl">Emergency contact person:</h3>
        <div class="row mb-4">

            <ValidationProvider
                class="col-md-6"
                name="Name of EC"
                v-slot="{ errors }"
                rules="required|min:3|latin"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Name of Emergency Contact Person</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="emergencyInfo.contact_name"
                    >
                    <FormError :error="errors[0]" name="Name of EC"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Relationship to EC"
                v-slot="{ errors }"
                rules="required|min:3|latin"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Relationship to your emergency contact person</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="emergencyInfo.relationship"
                    >
                    <FormError :error="errors[0]"  name="Relationship to EC"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Phone number of EC"
                v-slot="{ errors }"
                rules="required|min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Phone number of your emergency contact person</label>
                    <input
                        type="tel"
                        v-mask="'+1 (###) ###-####'"
                        class="form-control pl-4"
                        v-model="emergencyInfo.phone"
                    >
                    <FormError :error="errors[0]"  name="Phone number of EC"/>
                </div>
            </ValidationProvider>
        </div>

        <h3 class="profile__ttl">Vaccinations:</h3>
        <div class="row mb-4">
            <div class="col-12">
                <div class="form-group mb-3">
                    <label for="" class="form-label">Current Vaccinations</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="emergencyInfo.vaccinations"
                    >
                </div>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import FormError from "../Common/FormError.vue";

export default {
    name: 'EmergencyContactsAndVaccinations',
    components: {FormError},
    watch: {
        emergencyInfo: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    },
    mounted() {
        this.dispatchState(this.emergencyInfo);
    },

    computed: {
        ...mapState(useArtistStore, {
            emergencyInfo: 'emergencyInfo',
        }),
    }
}

</script>

<style scoped>

</style>
